/* Brody's landing pages: phone carousels (dots), "See More" on product cards, one-open FAQ.
   No polling, no section-ID selectors; everything keys off data-brodys-* attributes. */
(() => {
  const initCarousel = (root) => {
    const track = root.querySelector('[data-brodys-lcarousel-track]');
    const dots = root.querySelector('[data-brodys-lcarousel-dots]');
    if (!track || !dots) return;
    const slides = [...track.children];
    if (slides.length < 2) return;
    dots.replaceChildren(
      ...slides.map((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'brodys-lcarousel__dot';
        dot.setAttribute('aria-label', `${i + 1} / ${slides.length}`);
        dot.addEventListener('click', () => track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
        return dot;
      })
    );
    const setActive = (index) => [...dots.children].forEach((d, i) => d.setAttribute('aria-current', i === index ? 'true' : 'false'));
    setActive(0);
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActive(slides.indexOf(e.target))),
      { root: track, threshold: 0.6 }
    );
    slides.forEach((s) => io.observe(s));
  };

  // Show "See More" only when the description is actually clamped (GemPages always showed it).
  const initMore = (btn) => {
    const desc = btn.previousElementSibling;
    if (!desc) return;
    const more = btn.textContent.trim();
    const less = btn.dataset.brodysLess || more;
    requestAnimationFrame(() => {
      if (desc.scrollHeight > desc.clientHeight + 1) btn.hidden = false;
    });
    btn.addEventListener('click', () => {
      const open = desc.classList.toggle('is-expanded');
      btn.textContent = open ? less : more;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  };

  const initFaq = (root) => {
    const items = [...root.querySelectorAll('details')];
    items.forEach((item) =>
      item.addEventListener('toggle', () => {
        if (item.open) items.forEach((other) => other !== item && (other.open = false));
      })
    );
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-brodys-lcarousel]:not([data-brodys-ready])').forEach((el) => {
      el.dataset.brodysReady = 'true';
      initCarousel(el);
    });
    scope.querySelectorAll('[data-brodys-more]:not([data-brodys-ready])').forEach((el) => {
      el.dataset.brodysReady = 'true';
      initMore(el);
    });
    scope.querySelectorAll('[data-brodys-lfaq]:not([data-brodys-ready])').forEach((el) => {
      el.dataset.brodysReady = 'true';
      initFaq(el);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
